
import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Input, Button, Label } from "reactstrap";
import { URL } from "../../api";
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from "../../Request";
import getPrivilegeList from "../../PrivilegeList";
const PermanentAddress = ({ customerDetails, states, fetchCities, citiesMap, disableEdit}) => {
  const { cid , lid } = useParams();
const privilegeList = getPrivilegeList();
  const [editableAddress, setEditableAddress] = useState({
    address: "-NA-",
    city: "-NA-",
    cityId: null,
    state: "-NA-",
    stateId: null,
    pincode: "-NA-",
    landMark: "-NA-",
  });

  const [initialAddress, setInitialAddress] = useState({ ...editableAddress });
  const [isEditable, setIsEditable] = useState(false);
  const [sameAsCurrent, setSameAsCurrent] = useState(false);

  useEffect(() => {
    if (customerDetails?.permanentAddress) {
      const a = customerDetails.permanentAddress;
      const updated = {
        address: a.address || "-NA-",
        city: a.cityName || "-NA-",
        cityId: a.cityId || null,
        state: a.stateName || "-NA-",
        stateId: a.state || null,
        pincode: a.pinCode || "-NA-",
        landMark: a.landMark || "-NA-",
      };
      setEditableAddress(updated);
      setInitialAddress(updated);
      if (a.state) fetchCities(a.stateName);
    }
  }, [customerDetails]);

  // Resolve the city from the pincode (pincode_master) when the stored city is blank.
  useEffect(() => {
    const pin = editableAddress.pincode;
    if (!pin || !/^\d{6}$/.test(String(pin).trim())) return;
    if (editableAddress.city && editableAddress.city !== "-NA-") return;
    let active = true;
    axiosInstance
      .get(`${URL.PINCODE_LOOKUP}/${String(pin).trim()}`)
      .then((r) => {
        const city = r.data && (r.data.city || r.data.district);
        if (active && city) setEditableAddress((prev) => ({ ...prev, city }));
      })
      .catch(() => {});
    return () => { active = false; };
  }, [editableAddress.pincode, editableAddress.city]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableAddress(prev => ({ ...prev, [name]: value }));
  };

  const handleStateChange = async (e) => {
    const selectedStateName = e.target.value;
    const selectedState = states.find(s => s.name === selectedStateName);
    if (selectedState) {
      await fetchCities(selectedState.name);
      setEditableAddress(prev => ({
        ...prev,
        state: selectedState.name,
        stateId: selectedState.id,
        city: "-NA-",
        cityId: null,
      }));
    }
  };

  const handleCityChange = (e) => {
    const selectedCityName = e.target.value;
    const cityList = citiesMap[editableAddress.stateId] || [];
    const selectedCity = cityList.find(c => c.name === selectedCityName);
    setEditableAddress(prev => ({
      ...prev,
      city: selectedCity?.name || "-NA-",
      cityId: selectedCity?.id || null,
    }));
  };

  const handleEditClick = () => setIsEditable(true);

  const handleCancelClick = () => {
    setEditableAddress({ ...initialAddress });
    setIsEditable(false);
    setSameAsCurrent(false);
  };

  const handleSameAsCurrent = () => {
    if (sameAsCurrent) {
      setEditableAddress({ ...initialAddress });
    } else if (customerDetails?.currentAddress) {
      const ca = customerDetails.currentAddress;
      setEditableAddress({
        address: ca.address || "-NA-",
        city: ca.cityName || "-NA-",
        cityId: ca.cityId || null,
        state: ca.stateName || "-NA-",
        stateId: ca.state || null,
        pincode: ca.pinCode || "-NA-",
        landMark: ca.landMark || "-NA-",
      });
      if (ca.stateName) fetchCities(ca.stateName);
    }
    setSameAsCurrent(!sameAsCurrent);
  };

  const handleUpdateClick = () => {
    updatePermanentAddress(editableAddress);
    setIsEditable(false);
    setSameAsCurrent(false);
  };

   const updatePermanentAddress = async (d) => {
  const payload = {
    customer_id: cid,
    lead_id: lid,
    address_type: 3,
    address: d.address,
    postal_code: d.pincode,
    landmark: d.landMark,
  };

  try {
    const response = await axiosInstance.post(URL.UPDATE_CURRENT_ADDRESS, payload);
    const result = response.data;

    if (result.message && result.message.toLowerCase().includes("pincode is invalid")) {
          toast.warning(result.message);
          setEditableAddress((prev) => ({
            ...prev,
            pincode: initialAddress.pincode, 
          }));
          return; 
        }
          if (result.message && result.message.toLowerCase().includes("no changes detected")) {
          toast.info("No changes were made.");
          setEditableAddress({ ...initialAddress }); 
          setIsEditable(false); 
          return;
        }

    toast.success(result.message || "Address updated successfully");

    // ✅ Update city and state in the UI if provided
    if (result.cityName && result.stateName && result.cityId && result.stateCode) {
      await fetchCities(result.stateName); // ensure city dropdown is populated
      setEditableAddress((prev) => ({
        ...prev,
        city: result.cityName,
        cityId: result.cityId,
        state: result.stateName,
        stateId: result.stateCode,
      }));
    }

  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Address update failed";
    toast.warning(errorMsg);
  }
};

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h6 className="heading-small text-muted mb-3">Permanent Address</h6>
        {isEditable && (
          <FormGroup check className="mb-0">
            <Label check>
              <Input type="checkbox" checked={sameAsCurrent} onChange={handleSameAsCurrent} /> Same as Current Address
            </Label>
          </FormGroup>
        )}
      </div>

      <div className="pl-lg-4">
        <Row>
          <Col md="12">
            <FormGroup>
              <label className="form-control-label" htmlFor="input-address">Address</label>
              <Input
                className="form-control-alternative"
                id="input-address"
                name="address"
                type="text"
                value={editableAddress.address}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg="12">
            <FormGroup>
              <label className="form-control-label" htmlFor="input-state">State</label>
              <Input
                className="form-control-alternative"
                id="input-state"
                name="state"
                type="select"
                value={editableAddress.state}
                onChange={handleStateChange}
                disabled={true}
              >
                <option value="">-- Select State --</option>
                {states.map((s) => (
                  <option key={s.id} value={s.name}>{s.name}</option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col lg="12">
            <FormGroup>
              <label className="form-control-label" htmlFor="input-city">City</label>
              <Input
                className="form-control-alternative"
                id="input-city"
                name="city"
                type="select"
                value={editableAddress.city}
                onChange={handleCityChange}
                disabled={true}
              >
                <option value="">-- Select City --</option>
                {editableAddress.city && editableAddress.city !== "-NA-" &&
                  !(citiesMap[editableAddress.stateId] || []).some((c) => c.name === editableAddress.city) && (
                    <option value={editableAddress.city}>{editableAddress.city}</option>
                  )}
                {(citiesMap[editableAddress.stateId] || []).map((c) => (
                  <option key={c.id} value={c.name}>{c.name}</option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg="12">
            <FormGroup>
              <label className="form-control-label" htmlFor="input-postal-code">Postal Code</label>
              <Input
                className="form-control-alternative"
                id="input-postal-code"
                name="pincode"
                type="text"
                value={editableAddress.pincode}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          <Col lg="12">
            <FormGroup>
              <label className="form-control-label" htmlFor="input-landmark">Landmark</label>
              <Input
                className="form-control-alternative"
                id="input-landmark"
                name="landMark"
                type="text"
                value={editableAddress.landMark}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
        </Row>

        {privilegeList.permanentAddressEdit &&  !disableEdit && (
          <Row>
            <Col className="text-right" xs="12">
              {!isEditable ? (
                <Button color="primary" size="sm" onClick={handleEditClick}>Edit</Button>
              ) : (
                <>
                  <Button color="secondary" size="sm" onClick={handleCancelClick}>Cancel</Button>
                  <Button color="primary" size="sm" onClick={handleUpdateClick}>Update</Button>
                </>
              )}
            </Col>
          </Row>
        )}
      </div>
      <hr className="my-4" />
    </div>
  );
};

export default PermanentAddress;
